import React, { useState } from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';
import { useClient } from '../../../../reactQuery/client';


function ClientSelector({ handleClientChange, isLoading, clients = [] }) {
  const [selectedClient, setSelectedClient] = useState("");
  const { responseData } = useClient(
    {
      pagination: false,
      noAccess: true,
    },
    "no-access-clients"
  );
  return (
    <FormControl className="client-select" disabled={isLoading}>
      <Select
        value={selectedClient}
        onChange={(e) => setSelectedClient(e.target.value)}
        displayEmpty
        className="select-box"
        renderValue={(selected) => {
          if (selected === "") {
            return <em>Select Client</em>;
          }
          return selected;
        }}
        options={responseData.map((el) => ({
          label: el.company_name,
          value: el.id,
        }))}
      >
        <MenuItem value="" disabled>
          <em>Select Client</em>
        </MenuItem>
        {responseData.map((client) => (
          <MenuItem
            key={client.client_id}
            value={client.company_name}
            onClick={() => handleClientChange(client.client_id)}
            className="dropdown-menu-options"
          >
            {client.company_name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default ClientSelector; 